<template>
  <div id="prop-glance">
  </div>
</template>

<script>
export default {
  data: function () {
    return {

    }
  },
}
</script>

<style lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

</style>